import { render, staticRenderFns } from "./app-table.vue?vue&type=template&id=3add79a1&scoped=true&"
import script from "./app-table.vue?vue&type=script&lang=js&"
export * from "./app-table.vue?vue&type=script&lang=js&"
import style0 from "./app-table.vue?vue&type=style&index=0&id=3add79a1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3add79a1",
  null
  
)

export default component.exports